export const GET_CATEGORY = 'GET_CATEGORY';
export const LOADING_CATEGORY = 'LOADING_CATEGORY';
export const SAVE_LOADER_CATEGORY = 'SAVE_LOADER_CATEGORY'